import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';

@Component({
  selector: 'app-healthpicks-operator-forgot-password',
  templateUrl: './healthpicks-operator-forgot-password.component.html',
  styleUrls: [
    '../style/global.css',
    './healthpicks-operator-forgot-password.component.css',
  ],
})
export class HealthpicksOperatorForgotPasswordComponent
  extends BaseLoginComponent
  implements OnInit
{
  private static readonly emailFormatRe =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z\d](?:[a-zA-Z\d-]{0,61}[a-zA-Z\d])?(?:\.[a-zA-Z\d](?:[a-zA-Z\d-]{0,61}[a-zA-Z\d])?)+$/;

  async init(): Promise<void> {}

  async changePassword(): Promise<void> {
    const emailTrimmed = this.email.trim();
    if (!emailTrimmed) {
      this.errorMessages.forgetpassword.email =
        'メールアドレスを入力してください。';
      return;
    }
    if (!HealthpicksOperatorForgotPasswordComponent.emailFormatRe.test(emailTrimmed)) {
      this.errorMessages.forgetpassword.email =
        'メールアドレスまたはパスワードを確認してください。';
      return;
    }
    this.email = emailTrimmed;

    // Delegate to BaseLoginComponent which handles the actual request and navigation
    return super.changePassword();
  }
}
